import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import AnswerItemTable from '@/components/table/AnswerItemTable'
import AnswerMemoCard from '@/components/card/AnswerMemoCard'
import AnswerWordAnalysisInfoCard from '@/components/card/AnswerWordAnalysisInfoCard'
import FaceMatchCard from '@/components/card/FaceMatchCard'
import PatternCard from '@/components/card/PatternCard'
import Answer from '@/models/answer'

export default {
  components: {
    AnswerItemTable,
    AnswerWordAnalysisInfoCard,
    AnswerMemoCard,
    FaceMatchCard,
    PatternCard
  },
  mixins: [
    pageLoading,
    pageTitle
  ],
  title () {
    return this.$t("pages.user.answers.show.title")
  },
  props: {
    repository: Object,
    id: Number,
    queryFrom: String
  },
  data () {
    return {
      answer: new Answer(),
      speedDial: false,
      pnChartData: {},
      faceChartData: {},
      backRouteParams: {
        'Matchingship': { name: 'matching-index' },
        'Pairingship': { name: 'root' }
      },
      memoEditMode: false,
      memoUpdating: false,
      memoError: null
    }
  },
  computed: {
    backRoute () {
      if (this.queryFrom) {
        return this.queryFrom
      } else {
        const route = this.backRouteParams[this.answer.answerership.answerershipable_type]
        return route ? route : { name: 'root' }
      }
    },
    titleIcon () {
      return this.$vuetify.icons[this.answer.answerership.answerershipableToClass.answerTitleIconKey]
    }
  },
  watch: {
    '$route' () { // notification link
      this.fetchData()
    },
    answer (_) {
      this.$store.commit('setBackRoute', this.backRoute)
    },
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.getById(this.id))
        this.answer = plainToClass(Answer, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async updateMemo (memo) {
      if (this.memoUpdating) {
        return
      }
      this.memoUpdating = true
      try {
        const response = new Response(await this.repository.update(this.id, {
          answer: { memo: memo }
        }))
        this.$store.commit('setSnackbar', response.snackbarParams)
        this.memoEditMode = false
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.memoUpdating = false
      }
    },
    onPnEdit () {
      this.$router.push({
        name: 'answer-edit',
        params: { id: this.answer.id },
      })
    },
    handleClickDocumentLink () {
      window.open('https://blog.kotsu.work/posts/about-kotsu/', '_blank')
    }
  }
}
